import headerBackground from './headerBackground';
import lines from './lines';

export default {
  headerBackground,
  lines,
};
